/**
 * Escaparate de subastas activas en el panel Subastas del mega menú.
 *
 * Consume cards.the-vault.mx/api/auctions?status=active (público, sin auth) y
 * pinta las que cierran primero, con su puja actual y un countdown en vivo.
 *
 * Si no hay subastas corriendo —el caso real al escribir esto: cero activas
 * desde el 2026-05-28— el bloque explicativo que ya viene en el Liquid se
 * queda tal cual, empujando a publicar una subasta. El panel nunca aparece
 * vacío ni presume inventario que no existe.
 *
 * Construye nodos DOM (nada de innerHTML con datos remotos).
 */
(function () {
  'use strict';

  var ENDPOINT = 'https://cards.the-vault.mx/api/auctions?status=active';
  var APP = 'https://cards.the-vault.mx';
  var MAX = 3;

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  function money(value) {
    var amount = Number(value);
    if (!isFinite(amount)) return '';
    return '$ ' + amount.toLocaleString('es-MX');
  }

  /** "2d 4h" · "4h 12m" · "12m 30s" · "Cierra ya" */
  function restante(endDate) {
    var ms = new Date(endDate).getTime() - Date.now();
    if (!isFinite(ms) || ms <= 0) return 'Cierra ya';

    var s = Math.floor(ms / 1000);
    var d = Math.floor(s / 86400);
    var h = Math.floor((s % 86400) / 3600);
    var m = Math.floor((s % 3600) / 60);

    if (d > 0) return d + 'd ' + h + 'h';
    if (h > 0) return h + 'h ' + m + 'm';
    return m + 'm ' + (s % 60) + 's';
  }

  function card(auction) {
    var link = el('a', 'mega-menu__auction');
    link.href = APP + '/auctions/' + encodeURIComponent(auction.id);

    // Sin imagen va un marcador del mismo alto: si no, esa tarjeta se encoge y
    // desalinea la fila (una subasta puede publicarse sin fotos).
    var imagen = Array.isArray(auction.images) ? auction.images[0] : null;
    if (typeof imagen === 'string' && imagen.indexOf('https://') === 0) {
      var img = document.createElement('img');
      img.className = 'mega-menu__auction-image';
      img.src = imagen;
      img.alt = '';
      img.loading = 'lazy';
      link.appendChild(img);
    } else {
      link.appendChild(el('span', 'mega-menu__auction-image mega-menu__auction-image--vacia', '🃏'));
    }

    link.appendChild(el('span', 'mega-menu__auction-title', String(auction.title || 'Subasta')));

    var precio = auction.current_price != null ? auction.current_price : auction.starting_price;
    link.appendChild(el('span', 'mega-menu__auction-price', money(precio)));

    var reloj = el('span', 'mega-menu__auction-clock', restante(auction.end_date));
    reloj.setAttribute('data-end', String(auction.end_date));
    link.appendChild(reloj);

    return link;
  }

  function render(mount, auctions) {
    var intro = mount.querySelector('[data-vault-auctions-intro]');
    if (intro) intro.hidden = true;

    var lista = el('div', 'mega-menu__auction-list');
    auctions.slice(0, MAX).forEach(function (auction) {
      lista.appendChild(card(auction));
    });
    mount.appendChild(lista);

    var verTodas = el('a', 'mega-menu__auction-link', 'Ver todas las subastas');
    verTodas.href = APP + '/auctions';
    mount.appendChild(verTodas);

    setInterval(function () {
      mount.querySelectorAll('[data-end]').forEach(function (reloj) {
        reloj.textContent = restante(reloj.getAttribute('data-end'));
      });
    }, 1000);
  }

  function init() {
    var mount = document.querySelector('[data-vault-auctions]');
    if (!mount) return;

    fetch(ENDPOINT)
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.json();
      })
      .then(function (data) {
        var auctions = Array.isArray(data) ? data : (data && data.auctions) || [];
        // Las que cierran primero son las que urgen.
        auctions.sort(function (a, b) {
          return new Date(a.end_date) - new Date(b.end_date);
        });
        if (auctions.length > 0) render(mount, auctions);
      })
      .catch(function (err) {
        // Se queda el explicativo: al comprador no se le muestra el error.
        //
        // Pero SÍ se avisa por consola. Este `catch` vacío es la razón de que
        // el widget llevara desde su despliegue sin funcionar nunca —el
        // endpoint no emitía CORS y el navegador descartaba cada respuesta— y
        // nadie lo notara: reparar el transporte y dejar la venda puesta
        // significa que la próxima ruptura se esconde igual de tiempo (ADR 003).
        if (window.console && console.warn) {
          console.warn('[vault-menu-auctions] falló ' + ENDPOINT + ' — ' + err.message);
        }
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
